import {
  Module, VuexModule, Mutation, Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  GET_STATEMENT,
  GET_STATEMENT_DETAIL,
  STATEMENT_SHEET,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'statement' })
export default class Statement extends VuexModule {
  dataStatement: any = [];

  dataStatementDetail: any = [];

  @Mutation
  mutateStatement(statement) {
    this.dataStatement = statement.data;
  }

  @Action({ commit: 'mutateStatement' })
  FetchStatement(params) {
    return Vue.axios({
      url: BASE_URL + GET_STATEMENT,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }

  @Mutation
  mutateStatementDetail(statement) {
    this.dataStatementDetail = statement;
  }

  @Action({ commit: 'mutateStatementDetail' })
  FetchStatementDetail(params) {
    return Vue.axios({
      url: BASE_URL + GET_STATEMENT_DETAIL,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data;
        } else {
          throw data;
        }
      })
      .catch((err) => err);
  }

  @Action
  StatementDownloadSheet(params) {
    return Vue.axios({
      url: BASE_URL + STATEMENT_SHEET,
      data: params,
      method: M_POST,
      responseType: 'blob',
    }).then(async (res) => {
      const contentType = res.headers['content-type'];

      if (contentType && contentType.includes('application/json')) {
        const text = await res.data.text();
        const json = JSON.parse(text);
        throw new Error(json?.status?.message || 'Export failed');
      }

      return res.data;
    });
  }
}
